// src/converters/standing.ts
import { Standing, Team } from '@/model';
import {
  StandingItemResponse,
  GetStandingByIdResponse,
  GetStandingsResponse,
  GetStandingsSummaryResponse,
  PostStandingResponse,
  PostStandingsBatchResponse,
  PutStandingResponse,
  PutStandingsOrderResponse,
} from '@/services/response/standing';
import { StageTeamSummaryResponse } from '@/services/response/stage';

const mapTeamSummary = (response: StageTeamSummaryResponse): Team => ({
  uuid: response.uuid,
  name: response.name,
  acronym: response.acronym ?? '',
  logo_path: response.logo_path,
} as unknown as Team);

const mapStandingItem = (response: StandingItemResponse): Standing => ({
  uuid: response.uuid,
  stage_uuid: response.stage?.uuid ?? null,
  team_uuid: response.team.uuid,
  team: mapTeamSummary(response.team),
  position: response.position,
  points: response.points,
  played: response.played,
  wins: response.wins,
  draws: response.draws,
  losses: response.losses,
  goals_for: response.goals_for,
  goals_against: response.goals_against,
  goal_diff: response.goal_diff,
  win_rate: response.win_rate ?? undefined,
  created_at: response.created_at,
  updated_at: response.updated_at,
});

export class StandingConverter {
  static toDomainFromPaginatedResponse(response: GetStandingsResponse): Standing[] {
    return response.data.map(mapStandingItem);
  }

  static toDomainFromSummaryResponse(response: GetStandingsSummaryResponse): Standing[] {
    return response.data.map(mapStandingItem);
  }

  static toDomainFromByIdResponse(response: GetStandingByIdResponse): Standing {
    return mapStandingItem(response);
  }

  static toDomainFromPostResponse(response: PostStandingResponse): Standing {
    return mapStandingItem(response);
  }

  static toDomainFromPutResponse(response: PutStandingResponse): Standing {
    return mapStandingItem(response);
  }

  static toDomainFromPostBatchResponse(response: PostStandingsBatchResponse): Standing[] {
    return response.data.map(mapStandingItem);
  }

  static toDomainFromPutOrderResponse(response: PutStandingsOrderResponse) {
    return response.data.map(item => ({
      uuid: item.uuid,
      position: item.position,
      team: mapTeamSummary(item.team),
      stage_uuid: item.stage?.uuid,
      updated_at: item.updated_at,
    }));
  }
}
